import LocalizedText from '@/common/components/LocalizedText';
import Link from 'next/link';
import logo from '@/assets/logo-gradient.png';

/**
 * Brand mark + wordmark for the dark header shared by the standalone public
 * pages (acts, articles, rulings, wzory, pytania, zmiany-w-prawie). Mirrors the
 * landing-page navbar: 36px rounded mark, 8px gap, bold wordmark.
 *
 * The header background (--navbar-background) is dark in every theme, so the
 * gradient (light) logo is imported directly instead of going through the
 * theme-aware BrandLogo, which would flip to the black mark on light themes.
 */
const PublicHeaderBrand = () => (
  <Link
    href="/"
    className="inline-flex items-center gap-2 text-2xl font-bold text-white hover:opacity-80 hover:text-white transition-opacity"
  >
    <img
      src={logo}
      alt=""
      width={36}
      height={36}
      className="w-9 h-9 rounded-lg object-cover"
    />
    <span><LocalizedText id="text_2b35ee3a7277" /></span>
  </Link>
);

export default PublicHeaderBrand;
